<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center nh-login-page" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">2Nomi Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>
                <form @submit.prevent="login">
                  <div class="nh-login-inputs">
                    <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label-placeholder="Email"
                        v-model="email"
                        v-on:keyup="validateEmail"
                        class="w-full mb-5 nh-inp"/>
                        <vs-alert :active="show_email_error" color="danger" icon="new_releases" >
                           <span>Invalid email!</span>
                        </vs-alert>
                    <vs-input
                        type="password"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="Password"
                        v-model="password"
                        v-on:keyup="validatePassword"
                        v-on:keyup.enter="submitLoginForm"
                        class="w-full mt-5 nh-inp" />
                        <vs-alert :active="show_password_error" color="danger" icon="new_releases" >
                           <span>Fill the password!</span>
                        </vs-alert>  
                      <div class="flex flex-wrap justify-left my-5">
                        <vs-button @click="viewFPDialog()" color="primary" type="flat">Forgot Password?</vs-button>
                      </div>
                      <!-- <vs-button  type="border">Register</vs-button> -->
                    <vs-button class="nh-login-btn" size="large" @click="submitLoginForm()">Login</vs-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  		<vs-row vs-justify="left">
			<!-- Dialog box for forgot password -->
			<vs-prompt
				color="warning"
				class="centerx"
				title="Forgot Password"
				acceptText="Send Email"
				@accept="sendForgotPasswordMail"
				:active.sync="forgot_password_dialog" vs-w="12">
				<div class="con-exemple-prompt">
					<div class="centerx labelx">
            <vs-input label="Email" v-model="fp_email" class="mt-5 w-full" name="fp-email" v-validate="'required'" />
            <vs-alert :active="forgot_password_error" color="danger" icon="new_releases" >
                <span>Invalid Email!</span>
            </vs-alert>  
					</div>							
				</div>
			</vs-prompt>			

			<!-- Dialog box for forgot password OTP -->
			<vs-prompt
				color="success"
				class="centerx"
				title="Forgot Password OTP"
				acceptText="Verify"
        @accept="verifyOTP"
				:active.sync="otp_screen" vs-w="12">
				<div class="con-exemple-prompt">
					<div class="centerx labelx">
            <v-otp-input
              input-classes="otp-input"
              separator="-"
              :num-inputs="6"
              :should-auto-focus="true"
              :is-input-num="true"
              @on-complete="handleOnComplete"
            /> 
					</div>							
				</div>
			</vs-prompt>
		
    	<!-- Dialog box for reset password -->
			<vs-prompt
				color="warning"
				class="centerx"
				title="Reset Password"
				acceptText="Reset"
				@accept="resetPassword"
				:active.sync="fp_reset_screen" vs-w="12">
				<div class="con-exemple-prompt">
					<div class="centerx labelx">
            <vs-input type="password" label="New Password" ref="fp_new_password" v-model="fp_new_password" class="mt-5 w-full" name="fp_new_password" v-validate="'required'" />
					</div>	
          <div class="centerx labelx">
            <vs-input type="password" label="Confirm Password" v-model="fp_confirm_password" class="mt-5 w-full" name="fp_confirm_password" v-validate="'required|confirmed:password'" data-vv-as="fp_new_password" />
					</div>						
				</div>
			</vs-prompt>
		</vs-row>
  </div>
</template>

<script>

import OtpInput from '@bachdgvn/vue-otp-input'
export default{
  components: {
    'v-otp-input': OtpInput
  },
  data () {
    return {
      email: '',
      password: '',
      response_message: '',
      show_email_error: false,
      show_password_error: false,
      forgot_password_dialog: false,
      forgot_password_error: false,
      fp_email: '',
      otp_screen: false,
      fp_error_otp: false,
      fp_otp: '',
      fp_reset_screen: false,
      fp_new_password: '',
      fp_confirm_password: ''
    }
  },
  methods: {
    submitLoginForm () {
      //  Authentication
      const checkEmail = this.validateEmail()
      const checkPass = this.validatePassword()
      if (this.show_email_error == true || this.show_password_error == true) { console.log('Invalid form'); return false }

      this.$vs.loading()
      // Api post for token
      this.$store.dispatch('login', { email: this.email, password: this.password })
        .then((resp) => {
        
          this.$vs.loading.close()
          if (resp.data.message.indexOf('Invalid') !== -1) {
            this.$vs.notify({title:'Attention!', text:'Invalid username or password', color:'warning', position:'top-right', icon:'error', time:5000})
            return false        
          }
          if (resp.data.message.indexOf('Staff not active') !== -1) {
            this.$vs.notify({title:'Attention!', text:'Account deactivated. Please contact with admin.', color:'danger', position:'top-right', icon:'error', time:5000})
            return false        
          }
          const usr_role = JSON.parse(localStorage.getItem('userInfo')).user_info.userRole
          let set_role = 'admin'
          if (usr_role == 'isStaff') { set_role = 'nh_staff' }
          if (usr_role == 'isUser') { set_role = 'user' }
          if (usr_role == 'isNursingHomeAdmin') { set_role = 'nh_admin' }
          this.$store.dispatch('updateUserRole', {aclChangeRole: this.$acl.change, userRole: set_role})

          if (set_role == 'admin') { this.$router.push('/').catch(() => {}) } else if (set_role == 'nh_admin') { this.$router.push('/nh-admin').catch(() => {}) } else if (set_role == 'nh_staff') { this.$router.push('/nhs-albums').catch(() => {}) } else { this.$router.push('/').catch(() => {}) }
        })
        .catch((err) => {
          this.$vs.loading.close()
          console.log(err)
          this.$vs.notify({title:'Something went wrong!', text:'Please try again after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
        })

    },
    validateEmail () {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!this.email) {
        this.show_email_error = true
        return false
      } else if (!re.test(this.email)) {
        this.show_email_error = true
        return false
      } else { this.show_email_error = false; return true }
    },
    validatePassword () {
      if (!this.password) {
        this.show_password_error = true
        return false
      } else { this.show_password_error = false; return true }
    },
    viewFPDialog () {
      this.forgot_password_dialog = true
    },
    sendForgotPasswordMail () {
      this.forgot_password_dialog = true 
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
     	if (!re.test(this.fp_email)) {
        this.forgot_password_error = true
        return false
      }
      this.$vs.loading()
      this.forgot_password_error = false	
      const payload = JSON.stringify({ email: this.fp_email })		
      this.$http.post('/forgot-password/', payload)
        .then((response) => { 
          this.$vs.loading.close()
          if (response.data.messageType == 'success') {
            this.$vs.notify({title:'Great!', text:response.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
            this.forgot_password_dialog = false
            localStorage.setItem('otp', response.data.otp)
            this.viewOTPScreen()
          } else {
            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            this.forgot_password_dialog = true
            localStorage.removeItem('otp')
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          this.forgot_password_dialog = true
          localStorage.removeItem('otp')
        })
    },
    viewOTPScreen () {
      console.log(localStorage.getItem('otp'))
      this.otp_screen = true
    },
    handleOnComplete (value) {
      this.fp_otp = value
    },
    verifyOTP () {
      if (this.fp_otp == localStorage.getItem('otp')) {
        this.$vs.loading.close()
        this.otp_screen = false
        this.viewResetPasswordScreen()
      } else {
        this.otp_screen = true
        this.$vs.notify({title:'Oops!', text:'Your OTP is wrong!', color:'danger', position:'top-right', icon:'error', time:5000})
      }
    },
    viewResetPasswordScreen () {
      this.fp_reset_screen = true
    },
    resetPassword () {
      this.fp_reset_screen = true
      if (!this.fp_new_password || !this.fp_confirm_password) {
        this.$vs.notify({title:'Attention!', text:'Fields are required!', color:'warning', position:'top-right', icon:'error', time:5000})
        return false
      }
      
      if (this.fp_new_password != this.fp_confirm_password) {
        this.$vs.notify({title:'Attention!', text:'Password does not matched!', color:'warning', position:'top-right', icon:'error', time:5000})
        return false
      }

      this.$vs.loading()
      const payload = JSON.stringify({ 'email': this.fp_email, 'otp':this.fp_otp, 'new_password': this.fp_new_password })		
      console.log(payload)
      this.$http.post('/reset-password/', payload)
        .then((response) => { 
          this.$vs.loading.close()
          if (response.data.messageType == 'success') {
            this.$vs.notify({title:'Great!', text:response.data.message, color:'success', position:'top-right', icon:'check_box', time:5000})
            this.fp_reset_screen = false
            localStorage.removeItem('otp')
          } else {
            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            this.fp_reset_screen = true
            //localStorage.removeItem('otp')
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          this.fp_reset_screen = true
        //localStorage.removeItem('otp')
        })
    }
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
  .otp-input {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 8px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
.vs-component.vs-con-input-label.vs-input { padding: 12px 0 0; }
</style>
